"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_icons_1 = require("@carvana/helios-icons");
var helios_styles_1 = require("@carvana/helios-styles");
var test_attributes_1 = require("@carvana/test-attributes");
var react_1 = require("react");
var useMediaQuery_1 = __importDefault(require("../useMediaQuery"));
var hooks_1 = require("./hooks");
var Modal_styles_1 = require("./Modal.styles");
var ModalContext_1 = __importDefault(require("./ModalContext"));
exports.ModalComponent = (0, react_1.forwardRef)(function (props, ref) {
    var _a = props.backIcon, backIcon = _a === void 0 ? false : _a, children = props.children, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.closeIcon, closeIcon = _c === void 0 ? true : _c, _d = props.desktopWidth, desktopWidth = _d === void 0 ? '704px' : _d, _e = props.desktopMaxHeight, desktopMaxHeight = _e === void 0 ? 'calc(100vh - 20vh)' : _e, _f = props.divLine, divLine = _f === void 0 ? true : _f, _g = props.drawerOffset, drawerOffset = _g === void 0 ? '0' : _g, _h = props.drawerSide, drawerSide = _h === void 0 ? 'right' : _h, _j = props.drawerStyle, drawerStyle = _j === void 0 ? 'none' : _j, _k = props.drawerWidth, drawerWidth = _k === void 0 ? '25vw' : _k, _l = props.mobileStyle, mobileStyle = _l === void 0 ? 'full' : _l, _m = props.modalHeader, modalHeader = _m === void 0 ? null : _m, closeModal = props.closeModal, _o = props.onClickBack, onClickBack = _o === void 0 ? null : _o, _p = props.onClose, onClose = _p === void 0 ? null : _p, _q = props.zIndex, zIndex = _q === void 0 ? 9999999 : _q, _r = props.disableOutsideClose, disableOutsideClose = _r === void 0 ? false : _r, _s = props.disableEscapeClose, disableEscapeClose = _s === void 0 ? false : _s, _t = props.showHandle, showHandle = _t === void 0 ? true : _t, _u = props.contentOverflow, contentOverflow = _u === void 0 ? false : _u, isMultiPage = props.isMultiPage, rest = __rest(props, ["backIcon", "children", "className", "closeIcon", "desktopWidth", "desktopMaxHeight", "divLine", "drawerOffset", "drawerSide", "drawerStyle", "drawerWidth", "mobileStyle", "modalHeader", "closeModal", "onClickBack", "onClose", "zIndex", "disableOutsideClose", "disableEscapeClose", "showHandle", "contentOverflow", "isMultiPage"]);
    var _v = (0, react_1.useState)(0), height = _v[0], setHeight = _v[1];
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    var modalRef = (0, react_1.useRef)(null);
    var _w = (0, react_1.useContext)(ModalContext_1.default), modalHistoryRef = _w.modalHistoryRef, pageSetRef = _w.pageSetRef, setAnimationState = _w.setAnimationState, setMobileStyle = _w.setMobileStyle;
    (0, hooks_1.useTrapFocus)(modalRef);
    var isMobile = (0, useMediaQuery_1.default)("(max-width: ".concat(helios_styles_1.breakpoint.sm, ")"));
    var isTablet = (0, useMediaQuery_1.default)("(max-width: ".concat(helios_styles_1.breakpoint.md, ")"));
    var isDrawer = !isMobile && (drawerStyle === 'all' || (drawerStyle === 'tablet-only' && isTablet));
    var isDraggable = mobileStyle === 'sheet' && isMobile;
    var hasHeader = modalHeader || divLine;
    var _x = (0, react_1.useState)(false), isIntersecting = _x[0], setIntersecting = _x[1];
    var _y = (0, react_1.useState)(false), closing = _y[0], setClosing = _y[1];
    var observer = (0, react_1.useMemo)(function () { return new IntersectionObserver(function (_a) {
        var entry = _a[0];
        return setIntersecting(entry.isIntersecting);
    }); }, [modalRef]);
    var synchronizeRefs = function (element) {
        modalRef.current = element;
        if (!ref)
            return;
        if (typeof ref === 'function') {
            ref(element);
        }
        else {
            ref.current = element;
        }
    };
    (0, react_1.useEffect)(function () {
        observer.observe(modalRef.current);
        return function () { return observer.disconnect(); };
    }, []);
    (0, react_1.useEffect)(function () {
        setMobileStyle(mobileStyle);
        setHeight(modalRef.current.offsetHeight);
    }, []);
    var handleBackClick = function (e) {
        e.preventDefault();
        if (onClickBack) {
            onClickBack(e);
        }
        if (modalHistoryRef.current.length > 0) {
            var prevPage_1 = modalHistoryRef.current.pop();
            pageSetRef.current.delete(prevPage_1);
            setAnimationState(function (prevState) { return ({
                currentId: prevPage_1,
                animatingId: prevState.currentId,
                direction: -1
            }); });
        }
    };
    var handleModalClose = function () {
        if (isDrawer) {
            setClosing(true);
            setTimeout(function () {
                if (onClose) {
                    onClose();
                }
                closeModal();
            }, 500);
        }
        else {
            if (onClose) {
                onClose();
            }
            closeModal();
        }
    };
    (0, hooks_1.useOutsideClick)(modalRef, handleModalClose, { disable: disableOutsideClose });
    (0, hooks_1.useKeyPress)('Escape', handleModalClose, { disable: disableEscapeClose });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Modal_styles_1.Overlay, { "data-testid": "modal-overlay", zIndex: zIndex, offset: drawerOffset, drawerStyle: drawerStyle }), (0, jsx_runtime_1.jsxs)(Modal_styles_1.ModalContainer, __assign({ role: "dialog", "aria-modal": "true", desktopWidth: desktopWidth, desktopMaxHeight: desktopMaxHeight, offset: drawerOffset, drawerStyle: drawerStyle, drawerSide: drawerSide, drawerWidth: drawerWidth, mobileStyle: mobileStyle, contentOverflow: contentOverflow, ref: synchronizeRefs, "data-testid": "modal-container" }, getTestAttributes('modal'), { zIndex: zIndex, className: className, drag: isDraggable ? 'y' : false, dragConstraints: { top: 0, bottom: height }, dragElastic: 0.1, dragMomentum: false, onDragEnd: function () {
                    if (!isIntersecting) {
                        handleModalClose();
                    }
                }, whileTap: { cursor: isDraggable ? 'grabbing' : 'auto' } }, rest, { closing: closing }, { children: [showHandle && mobileStyle === 'sheet' && ((0, jsx_runtime_1.jsx)(Modal_styles_1.HandleWrapper, { children: (0, jsx_runtime_1.jsx)(Modal_styles_1.Handle, {}) })), (0, jsx_runtime_1.jsxs)(Modal_styles_1.HeaderContainer, __assign({ divLine: divLine }, { children: [(backIcon || modalHistoryRef.current.length > 0) && ((0, jsx_runtime_1.jsx)(Modal_styles_1.IconContainer, __assign({ className: "Helios__back-icon", onClick: handleBackClick, "aria-label": "Back", "data-testid": "back-button" }, { children: (0, jsx_runtime_1.jsx)(helios_icons_1.Caret, { direction: "left", "aria-hidden": "true" }) }))), (0, jsx_runtime_1.jsx)(Modal_styles_1.Header, { children: modalHeader }), closeIcon && ((0, jsx_runtime_1.jsx)(Modal_styles_1.IconContainer, __assign({ className: "Helios__close-icon", onClick: handleModalClose, "aria-label": "Close", "data-testid": "close-button" }, { children: (0, jsx_runtime_1.jsx)(helios_icons_1.XIcon, { size: 16, "aria-hidden": "true" }) })))] })), (0, jsx_runtime_1.jsx)(Modal_styles_1.ModalBody, __assign({ isMultiPage: isMultiPage, contentOverflow: contentOverflow, className: "Helios__modal-body ".concat(hasHeader ? '' : 'no-header') }, { children: children }))] }))] }));
});
